import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map, take } from 'rxjs';
import { environment, HttpHeadersService } from '@perval/shared';
import {
  EditorRoleHttp,
  EditorRoles,
  EditorRolesHttp,
} from '../models/editor-roles-http.dto';

@Injectable({
  providedIn: 'root',
})
export class AttributesService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-reports/attributes`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  async getReportRoles(): Promise<EditorRoles> {
    return await firstValueFrom(
      this.http
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .get<EditorRolesHttp>(`${this.mainUrl}/editor_roles`, {
          headers:
            await this.httpHeadersServiceService.getHeadersWithPervalContext(),
        })
        .pipe(
          take(1),
          map((editorRoles: EditorRolesHttp) => ({
            items: editorRoles.items.map((editorRole: EditorRoleHttp) => ({
              value: editorRole.slug,
              label: editorRole.label,
            })),
          })),
        ),
    );
  }
}
